import { useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { SettingsDrillContext } from './settings-drill-context';

/** Второй уровень того же листа: исходные поля остаются смонтированными и сохраняют состояние. */
export function SettingsDrill({ id, children }: { id: string; children: ReactNode }) {
  const drill = useContext(SettingsDrillContext);
  return drill?.page === id && drill.host ? createPortal(children, drill.host) : null;
}
